// Configuration de l'API
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000';

export const CORS_CONFIG = {
  credentials: 'include',
  headers: {
    'Content-Type': 'application/json',
  },
};

export const API_ENDPOINTS = {
  // Authentification
  LOGIN: `${API_BASE_URL}/v1/postgres/login`,
  REGISTER: `${API_BASE_URL}/v1/postgres/register`,
  ME: `${API_BASE_URL}/v1/postgres/me`,
  REFRESH: `${API_BASE_URL}/v1/auth/refresh`,
  LOGOUT: `${API_BASE_URL}/v1/postgres/signout`,
  ONBOARDING_VIDEO_COMPLETE: `${API_BASE_URL}/v1/postgres/onboarding-video/complete`,
  
  // Quotas
  QUOTA: `${API_BASE_URL}/v1/postgres/quota`,
  PLAN_LIMITS: `${API_BASE_URL}/v1/postgres/plan-limits`,
  
  // Pipeline
  PIPELINE_RUN: `${API_BASE_URL}/v1/pipeline/run`,
  
  // Filtres L2
  L2_FILTERS_GET: `${API_BASE_URL}/v1/postgres/l2-filters/get`,
  L2_FILTERS_UPDATE: `${API_BASE_URL}/v1/postgres/l2-filters/save`,
  
  // Sélections ASIN (couleurs)
  ASIN_SELECTIONS_GET: `${API_BASE_URL}/v1/postgres/asin-selections`,
  ASIN_SELECTIONS_SAVE: `${API_BASE_URL}/v1/postgres/asin-selections`,
  
  // Historique
  HISTORY: `${API_BASE_URL}/v1/postgres/pipeline/history/test`,
  HISTORY_DETAILS: (id: string) => `${API_BASE_URL}/v1/postgres/pipeline/history/${id}`,
  HISTORY_ALL_WINS: `${API_BASE_URL}/v1/postgres/pipeline/all-wins`,
  
  // Billing
  BILLING_PLANS: `${API_BASE_URL}/v1/postgres/billing/plans`,
  BILLING_SUBSCRIPTION: `${API_BASE_URL}/v1/postgres/billing/subscription`,
  BILLING_CHECKOUT: `${API_BASE_URL}/v1/postgres/billing/create-checkout-session`,
  BILLING_PORTAL: `${API_BASE_URL}/v1/postgres/billing/create-portal-session`,
  BILLING_CANCEL: `${API_BASE_URL}/v1/postgres/billing/cancel-subscription`,
  
  // Webhooks
  WEBHOOKS: `${API_BASE_URL}/v1/webhooks`,
  
  // Admin
  ADMIN_DATABASE_STATUS: `${API_BASE_URL}/v1/auth/admin/database-status`,
  ADMIN_CLEANUP_DATABASE: `${API_BASE_URL}/v1/auth/admin/cleanup-database`,
  ADMIN_PROMOTE_USER: `${API_BASE_URL}/v1/auth/admin/promote-user`,
  ADMIN_TOGGLE_USER_STATUS: `${API_BASE_URL}/v1/auth/admin/toggle-user-status`,
  ADMIN_DELETE_USER: `${API_BASE_URL}/v1/auth/admin/delete-user`,
  ADMIN_SETUP_ADMIN: `${API_BASE_URL}/v1/auth/admin/setup-admin`,
  
  // Email Verification
  EMAIL_VERIFICATION_STATUS: (email: string) => `${API_BASE_URL}/v1/auth/email-verification-status/${email}`,
  RESEND_VERIFICATION: `${API_BASE_URL}/v1/auth/resend-verification`,
  
  // Produits
  PRODUCT_ANALYZE: `${API_BASE_URL}/v1/product/analyze`,
  
  // Vendeurs
  SELLER_ANALYZE: `${API_BASE_URL}/v1/seller/analyze`,
  SELLER_CATALOG: `${API_BASE_URL}/v1/seller/catalog`,

  // Bestsellers et Query
  BESTSELLERS_CATEGORIES: `${API_BASE_URL}/v1/bestsellers/categories`,
  BESTSELLERS_PULL: `${API_BASE_URL}/v1/bestsellers/pull`,
  QUERY: `${API_BASE_URL}/v1/query`,

  // Database et Health
  DATABASE_OPERATION: `${API_BASE_URL}/v1/database/operation`,
  HEALTH: `${API_BASE_URL}/v1/health`,
  SEARCH: `${API_BASE_URL}/v1/search`,
};